import { defineNuxtPlugin } from '#app/nuxt'
import { LazyAccessibilityMenuPanel, LazyContentBlockContainer, LazyElocusPage, LazyHeroSliderEvent, LazyHeroSliderPage, LazyHeroSliderSlideBody, LazyHeroSliderSlide, LazyUIBreadCrumbs, LazyUIContentblockButton, LazyUIDocumentItem, LazyUIEventsDetailPage, LazyUIEventsFilterDate, LazyUIEventsFilterWrapper, LazyUIEventsOverviewListBanner, LazyUIEventsOverviewListItem, LazyUIEventsOverviewListItemPrograms, LazyUIEventsProgramOverview, LazyUIFaqItem, LazyUIFormComponent, LazyUIHeaderMobileMenuWrapper, LazyUIHeaderNavItem, LazyUIHeaderNavWrapper, LazyUIHeaderPrimary, LazyUIHeaderSecondary, LazyUIHeaderSubNav, LazyUIHeadingType, LazyUIHoverAnimationButton, LazyUIIconButton, LazyUIIconComponent, LazyUIImagesCarousel, LazyUIImagesGallery, LazyUIInputCheckbox, LazyUILinkComponent, LazyUIModal, LazyUIModuleActiveFilterChips, LazyUIModuleFilterListItems, LazyUIModuleFilterWrapperMobile, LazyUIOpeningTimes, LazyUIPageLoader, LazyUIPartnerLogo, LazyUIRelatedArticle, LazyUISearchInput, LazyUISearchItem, LazyUISearchNavigationWrapper, LazyUISearchResults, LazyUISearchResultSection, LazyUIVideoComponent, LazyUIVimeoPlayer, LazyUIYoutubePlayer, LazyAccessibilitySelector, LazyAccessibilitySkipLinks, LazyContentblockCube, LazyContentblockDocuments, LazyContentblockEmbed, LazyContentblockFaq, LazyContentblockForm, LazyContentblockHeader, LazyContentblockHeroSlider, LazyContentblockImage, LazyContentblockImages, LazyContentblockNewsArticles, LazyContentblockPartners, LazyContentblockQuickLinks, LazyContentblockRelatedArticles, LazyContentblockSubNavigation, LazyContentblockTestimonial, LazyContentblockTextAndImageVideo, LazyContentblockTextHighlight, LazyContentblockTextOneColumn, LazyContentblockTextTwoColumn, LazyContentblockTitle, LazyContentblockVideo, LazyContentblockEventsOverviewWrapper, LazyContentblockEventsRelated, LazyCubeFaceTitle, LazyHeroSlideContent, LazyLayoutFooter, LazyLayoutHeader, LazyBaseArticleInfiniteScroll, LazyBaseArticleOverview, LazyBaseArticlePagination, LazyBaseImage } from '#components'
const lazyGlobalComponents = [
  ["AccessibilityMenuPanel", LazyAccessibilityMenuPanel],
["ContentBlockContainer", LazyContentBlockContainer],
["ElocusPage", LazyElocusPage],
["HeroSliderEvent", LazyHeroSliderEvent],
["HeroSliderPage", LazyHeroSliderPage],
["HeroSliderSlideBody", LazyHeroSliderSlideBody],
["HeroSliderSlide", LazyHeroSliderSlide],
["UIBreadCrumbs", LazyUIBreadCrumbs],
["UIContentblockButton", LazyUIContentblockButton],
["UIDocumentItem", LazyUIDocumentItem],
["UIEventsDetailPage", LazyUIEventsDetailPage],
["UIEventsFilterDate", LazyUIEventsFilterDate],
["UIEventsFilterWrapper", LazyUIEventsFilterWrapper],
["UIEventsOverviewListBanner", LazyUIEventsOverviewListBanner],
["UIEventsOverviewListItem", LazyUIEventsOverviewListItem],
["UIEventsOverviewListItemPrograms", LazyUIEventsOverviewListItemPrograms],
["UIEventsProgramOverview", LazyUIEventsProgramOverview],
["UIFaqItem", LazyUIFaqItem],
["UIFormComponent", LazyUIFormComponent],
["UIHeaderMobileMenuWrapper", LazyUIHeaderMobileMenuWrapper],
["UIHeaderNavItem", LazyUIHeaderNavItem],
["UIHeaderNavWrapper", LazyUIHeaderNavWrapper],
["UIHeaderPrimary", LazyUIHeaderPrimary],
["UIHeaderSecondary", LazyUIHeaderSecondary],
["UIHeaderSubNav", LazyUIHeaderSubNav],
["UIHeadingType", LazyUIHeadingType],
["UIHoverAnimationButton", LazyUIHoverAnimationButton],
["UIIconButton", LazyUIIconButton],
["UIIconComponent", LazyUIIconComponent],
["UIImagesCarousel", LazyUIImagesCarousel],
["UIImagesGallery", LazyUIImagesGallery],
["UIInputCheckbox", LazyUIInputCheckbox],
["UILinkComponent", LazyUILinkComponent],
["UIModal", LazyUIModal],
["UIModuleActiveFilterChips", LazyUIModuleActiveFilterChips],
["UIModuleFilterListItems", LazyUIModuleFilterListItems],
["UIModuleFilterWrapperMobile", LazyUIModuleFilterWrapperMobile],
["UIOpeningTimes", LazyUIOpeningTimes],
["UIPageLoader", LazyUIPageLoader],
["UIPartnerLogo", LazyUIPartnerLogo],
["UIRelatedArticle", LazyUIRelatedArticle],
["UISearchInput", LazyUISearchInput],
["UISearchItem", LazyUISearchItem],
["UISearchNavigationWrapper", LazyUISearchNavigationWrapper],
["UISearchResults", LazyUISearchResults],
["UISearchResultSection", LazyUISearchResultSection],
["UIVideoComponent", LazyUIVideoComponent],
["UIVimeoPlayer", LazyUIVimeoPlayer],
["UIYoutubePlayer", LazyUIYoutubePlayer],
["AccessibilitySelector", LazyAccessibilitySelector],
["AccessibilitySkipLinks", LazyAccessibilitySkipLinks],
["ContentblockCube", LazyContentblockCube],
["ContentblockDocuments", LazyContentblockDocuments],
["ContentblockEmbed", LazyContentblockEmbed],
["ContentblockFaq", LazyContentblockFaq],
["ContentblockForm", LazyContentblockForm],
["ContentblockHeader", LazyContentblockHeader],
["ContentblockHeroSlider", LazyContentblockHeroSlider],
["ContentblockImage", LazyContentblockImage],
["ContentblockImages", LazyContentblockImages],
["ContentblockNewsArticles", LazyContentblockNewsArticles],
["ContentblockPartners", LazyContentblockPartners],
["ContentblockQuickLinks", LazyContentblockQuickLinks],
["ContentblockRelatedArticles", LazyContentblockRelatedArticles],
["ContentblockSubNavigation", LazyContentblockSubNavigation],
["ContentblockTestimonial", LazyContentblockTestimonial],
["ContentblockTextAndImageVideo", LazyContentblockTextAndImageVideo],
["ContentblockTextHighlight", LazyContentblockTextHighlight],
["ContentblockTextOneColumn", LazyContentblockTextOneColumn],
["ContentblockTextTwoColumn", LazyContentblockTextTwoColumn],
["ContentblockTitle", LazyContentblockTitle],
["ContentblockVideo", LazyContentblockVideo],
["ContentblockEventsOverviewWrapper", LazyContentblockEventsOverviewWrapper],
["ContentblockEventsRelated", LazyContentblockEventsRelated],
["CubeFaceTitle", LazyCubeFaceTitle],
["HeroSlideContent", LazyHeroSlideContent],
["LayoutFooter", LazyLayoutFooter],
["LayoutHeader", LazyLayoutHeader],
["BaseArticleInfiniteScroll", LazyBaseArticleInfiniteScroll],
["BaseArticleOverview", LazyBaseArticleOverview],
["BaseArticlePagination", LazyBaseArticlePagination],
["BaseImage", LazyBaseImage],
  
]

export default defineNuxtPlugin({
  name: 'nuxt:global-components',
  setup (nuxtApp) {
    for (const [name, component] of lazyGlobalComponents) {
      nuxtApp.vueApp.component(name, component)
      nuxtApp.vueApp.component('Lazy' + name, component)
    }
  }
})
